<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-14 10:23:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:28:31
 * @FilePath: \mrc-base-frontend\src\views\menu_manage\index.vue
-->
<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div class="menu_list" v-if="$route.name === 'menu_manage'">
      <mrc_ess_addBtn
        @handleAdd="handleAdd"
        v-btnAuth="['add-menu']"
      ></mrc_ess_addBtn>
      <v-card style="text-align: left">
        <!-- <v-card-subtitle style="font-size: 19px;color: #ffad4d">Applicant Tracking System</v-card-subtitle> -->
        <v-card-text class="pt-0">
          <v-sheet
            class="
              d-flex
              align-center
              justify-space-between
              pt-6
              pb-4
              text--secondary
            "
          >
            <v-sheet class="text--secondary ml-10">
              {{ $t("label_The_menu") }}
            </v-sheet>
            <v-sheet class="d-flex mr-2">
              <v-sheet width="20vw" class="text--secondary">
                {{ $t("label_The_name_of_the_function") }}
              </v-sheet>
              <v-sheet width="10vw" class="text--secondary">{{
                $t("label_Whether_to_enable")
              }}</v-sheet>
            </v-sheet>
          </v-sheet>
          <div
            v-for="(treelist, index) in menuList"
            :key="index"
            class="box"
            :class="index !== 0 ? 'mt-5' : ''"
            style="border-radius: 8px; border: 1px solid #e8e8e8"
          >
            <v-treeview
              hoverable
              open-on-click
              item-key="uuid"
              item-children="children"
              expand-icon="arrow_drop_down"
              :items="[treelist]"
            >
              <template v-slot:label="{ item }">
                {{ INT(item.menu_name) }}
                <span style="display: none">
                  {{ item.menu_name }}
                </span>
              </template>
              <template v-slot:append="{ item }">
                <v-sheet class="d-flex align-center justify-space-between">
                  <v-sheet width="20vw">
                    {{ INT(item.menu_name) }}
                  </v-sheet>

                  <v-sheet
                    width="10vw"
                    class="d-flex align-center justify-space-between"
                  >
                    <mrc_ess_viewbtn :is_used="item.is_show"></mrc_ess_viewbtn>
                    <menu-list
                      :list="[
                        {
                          name: $t('label_View'),
                          show: hasBtn('view-menu'),
                          type: 'view',
                        },
                        {
                          name: $t('label_Edit'),
                          show: hasBtn('edit-menu'),
                          type: 'edit',
                        },
                        {
                          name: $t('label_delete'),
                          show: hasBtn('delete-menu'),
                          type: 'del',
                        },
                      ]"
                      @handleClick="handleClick($event, item)"
                    >
                      <template v-slot:showAction>
                        <v-icon
                          v-btnAuth="['edit-menu', 'delete-menu', 'view-menu']"
                          >mdi-dots-vertical</v-icon
                        >
                      </template>
                    </menu-list>
                  </v-sheet>
                </v-sheet>
              </template>
            </v-treeview>
          </div>
          <!-- <menu-list-manage v-for="(item, index) in menuList"
                            :key="index"
                            :obj="item"
                            @delData="delData"
                            :level="0"></menu-list-manage> -->
        </v-card-text>
      </v-card>
    </div>
    <router-view v-else></router-view>
  </mrc_ess_skeleton_loader>
</template>

<script>
import menuListManage from "./menu_list";
import { get_menuList, del_menu } from "@/service/api/menu";
export default {
  components: { menuListManage },
  props: {},
  data() {
    return {
      menuList: [],
      skLoading: true,
    };
  },
  async created() {
    await this.getBtnPermissionList();
  },
  async mounted() {
    this.skLoading = true;
    if (this.$route.name == "menu_manage") {
      const menu = await get_menuList();
      if (menu.code == 200) {
        this.menuList = menu.data;
      }
    }
    this.skLoading = false;
  },
  methods: {
    handleAdd() {
      this.$router.push({
        name: "menu_add",
      });
    },
    delData(uuid) {
      this.Recursion(this.menuList, uuid);
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.$store.commit("set_subPage_name", obj.menu_name);
          this.$store.commit("set_uuid", obj.uuid);
          this.$store.commit("set_iconstatus", true);
          this.$router.push({
            name: "menu_detail",
            params: {
              name: obj.menu_name,
              uuid: obj.uuid,
            },
          });
          break;
        case "edit":
          this.$store.commit("set_subPage_name", obj.menu_name);
          this.$store.commit("set_uuid", obj.uuid);
          this.$store.commit("set_iconstatus", false);
          this.$router.push({
            name: "menu_detail",
            params: {
              name: obj.menu_name,
              uuid: obj.uuid,
            },
          });
          break;
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          })
            .then(async () => {
              const del = await del_menu({ uuid: obj.uuid });
              if (del.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                });
                this.delData(obj.uuid);
              }
            })
            .catch(() => {
              // console.log('点了取消')
            });
          break;
      }
    },
    Recursion(arr, uuid) {
      if (arr.length <= 0) return "";
      arr.forEach((item, index) => {
        if (item.uuid == uuid) {
          arr.splice(index, 1);
        } else {
          if (item.children) {
            this.Recursion(item.children, uuid);
          }
        }
      });
    },
  },
  computed: {},
  watch: {
    async $route(val) {
      if (val.name === "menu_manage") {
        this.skLoading = true;
        const menu = await get_menuList();
        if (menu.code == 200) {
          this.menuList = menu.data;
        }
        this.skLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.menu_row {
  display: flex;
}
.menu_name {
  width: 38vw;
  padding-left: 20px;
}
.func_name {
  width: 19vw;
}
.is_show {
  width: 5vw;
}
/* /deep/ .v-treeview-node__root {
  border-bottom: 1px solid #e8e8e8;
}
/deep/ .v-treeview-node__root:last-child {
  border-bottom: none;
} */
/* /deep/ .v-treeview-node {
  margin-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 8px;
}
/deep/ .v-treeview-node__root:first-of-type {
  border-radius: 8px;
}
/deep/ .v-treeview-node__root {
  border: 1px solid #e8e8e8;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom: none;
  height: 60px;
}
/deep/ .v-treeview-node__children .v-treeview-node,
/deep/ .v-treeview-node__children .v-treeview-node__root {
  border-bottom: none;
  margin-bottom: 0;
  border-radius: inherit;
}
/deep/
  .v-treeview-node__children:last-child
  .v-treeview-node:last-child
  .v-treeview-node__root:last-child {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
/deep/ .v-treeview-node__root:last-child {
  border-top-right-radius: inherit;
  border-top-left-radius: inherit;
} */
</style>
